/**
 * @file: dateRangeTillToday.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DateRange } from '@euler/model/common';
import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import addYears from 'date-fns/addYears';
import format from 'date-fns/format';

export function dateRangeTillToday(
  offset: number,
  unit: 'day' | 'month' | 'year' = 'day',
): DateRange {
  return {
    startDate: format(
      unit === 'day'
        ? addDays(new Date(), -offset)
        : unit === 'month'
        ? addMonths(new Date(), -offset)
        : addYears(new Date(), -offset),
      'yyyy-MM-dd',
    ),
    startInclusive: true,
  };
}
